'use client';

import { useState } from 'react';
import Image from 'next/image';
import clsx from 'clsx';

import PreviewImage from '@public/images/promo-preview.png';
import PlayIcon from '@public/icons/play-round.svg';

import { VIDEO_URL } from '../../config/video';

import styles from './VideoCard.module.scss';

interface VideoCardProps {
  containerClassName?: string;
  videoClassName?: string;
}

const VideoCard = (props: VideoCardProps) => {
  const { containerClassName, videoClassName } = props;

  const [iframeVisible, setIframeVisible] = useState<boolean>(false);

  return (
    <div className={clsx(styles.container, containerClassName)}>
      {iframeVisible ? (
        <iframe
          src={VIDEO_URL}
          title="Promo"
          className={clsx(styles.video, videoClassName)}
          loading="lazy"
          allow="accelerometer; gyroscope; autoplay; encrypted-media;"
          allowFullScreen
        />
      ) : (
        <div className={styles.preview} onClick={() => setIframeVisible(true)}>
          <Image
            src={PreviewImage}
            className={styles.preview_image}
            alt="Promo preview"
            quality={100}
            draggable={false}
          />

          <Image src={PlayIcon} className={styles.preview_play} alt="Play" draggable={false} />
        </div>
      )}
    </div>
  );
};

export default VideoCard;
